import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class LogErrorHandler implements ErrorHandler {
  constructor(private logger: LoggerService) {}

  handleError(error: unknown): void {
    const msg =
      error instanceof Error ? error.stack || error.message : String(error);
    this.logger.push('[ERROR] ' + msg);
    console.error(error);
  }
}
